import { render, staticRenderFns } from "./invoice-list-separate.vue?vue&type=template&id=25203d86&scoped=true&"
import script from "./invoice-list-separate.vue?vue&type=script&lang=js&"
export * from "./invoice-list-separate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25203d86",
  null
  
)

export default component.exports